import AboutSection from '../../sections/AboutSection';
import VisorSection from '../../sections/VisorSection';
import FasesSection from '../../sections/FasesSection';
import Gallery from '../../sections/Gallery';
import Descargas from '../../components/Descargas';
import Hero from '../../components/Hero';
import { motion, AnimatePresence } from "framer-motion";
import { FaFilePdf, FaProjectDiagram, FaLightbulb, FaClipboardList, FaMap } from "react-icons/fa";
import { DocumentRepository2 } from '../../components/DocumentRepository';

import './AltosNorte.CSS';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { 
  Home as HomeIcon,
  MapPin as MapPinIcon,
  FileText as FileTextIcon,
  Phone as PhoneIcon,
  ChevronDown,
  ChevronRight,
  Menu,
  X,
  ExternalLink,
  Subtitles,
  Users,
  Map,
  Landmark,
  Calendar,MapPin,Info, MountainSnow, Tree,TreePineIcon, ClockIcon,Book,BookOpen,FileSearch,Layers,Target,FileText,File,FileIcon,Download,DownloadIcon,Document,DocumentIcon,
  CheckIcon,FilePdf,FilePdfIcon,ProjectDiagram,ProjectDiagramIcon,Lightbulb,LightbulbIcon,ClipboardList,ClipboardListIcon,CheckCircle,CheckCircleIcon,
  Compass,GlobeIcon,DownloadCloud,DownloadCloudIcon,FileArchive,FileArchiveIcon,Folder,FolderIcon,FolderOpen,FolderOpenIcon,Link,LinkIcon,ExternalLinkIcon,
  ArrowDown,LayersIcon,FileSignature,Zap,FileSpreadsheet,BarChart3,Waves
} from 'lucide-react';

const ModernBitacoraSection = ({ items }) => {
  const [expandedSection, setExpandedSection] = useState(0);

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white dark:from-gray-900 dark:to-gray-800" id="bitacora">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
              Bitácora del Programa
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Registro documental completo del proceso de ordenamiento ecológico
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <motion.button
                key={index}
                onClick={() => setExpandedSection(expandedSection === index ? null : index)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`p-6 rounded-2xl transition-all duration-300 text-left ${
                  expandedSection === index
                    ? `bg-gradient-to-br ${item.color} text-white shadow-2xl`
                    : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 shadow-lg hover:shadow-xl'
                }`}
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className={`p-3 rounded-xl ${
                    expandedSection === index
                      ? 'bg-white/20'
                      : `bg-gradient-to-br ${item.color}`
                  }`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="text-lg font-semibold">{item.title}</h3>
                </div>
                <p className={`text-sm ${
                  expandedSection === index ? 'text-white/90' : 'text-gray-500 dark:text-gray-400'
                }`}>
                  {expandedSection === index ? 'Ver documentos ↓' : 'Ver documentos →'}
                </p>
              </motion.button>
            );
          })}
        </div>

        <AnimatePresence>
          {expandedSection !== null && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
              className="overflow-hidden"
            >
              <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-xl border border-gray-100 dark:border-gray-700">
                {items[expandedSection].content.map((section, sectionIndex) => (
                  <div key={sectionIndex} className="mb-8 last:mb-0">
                    <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-6 flex items-center">
                      <div className="w-3 h-3 bg-gradient-to-r from-blue-500 to-teal-500 rounded-full mr-3" />
                      {section.subtitle}
                    </h4>
                    <div className="grid md:grid-cols-2 gap-4">
                      {section.items.map((doc, docIndex) => (
                        <a
                          key={docIndex}
                          href={doc.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="group p-4 bg-gray-50 dark:bg-gray-700 rounded-xl hover:bg-gradient-to-r hover:from-blue-50 hover:to-teal-50 
                            dark:hover:from-blue-900/20 dark:hover:to-teal-900/20 transition-all duration-300"
                        >
                          <div className="flex items-center gap-3">
                            <FileText className="w-5 h-5 text-blue-500 group-hover:text-teal-500 transition-colors" />
                            <span className="text-gray-700 dark:text-gray-300 group-hover:text-gray-900 dark:group-hover:text-white">
                              {doc.text}
                            </span>
                          </div>
                        </a>
                      ))}
                    </div>
                  </div>
                ))}
                
                <div className="mt-8 pt-6 border-t border-gray-100 dark:border-gray-700">
                  <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
                    {items[expandedSection].content.reduce((total, section) => total + section.items.length, 0)} documentos disponibles
                  </p>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};

const FullWidthVisorWithSidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState('uga');

  return (
    <section id="visor-completo" className="py-16">
      <div className="max-w-[2000px] mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
              Plataforma Geoespacial Completa
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
            Sistema de información geográfica integrado con documentación técnica completa
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          <motion.div
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            className={`lg:w-96 ${sidebarOpen ? 'block' : 'hidden lg:block'}`}
          >
            <div className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-xl border border-gray-100 dark:border-gray-700 sticky top-6">
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className="lg:hidden mb-4 w-full p-2 bg-gradient-to-r from-blue-500 to-teal-500 
                  text-white rounded-lg flex items-center justify-center gap-2"
              >
                {sidebarOpen ? 'Ocultar Panel' : 'Mostrar Panel'}
                <ChevronRight className={`w-4 h-4 transition-transform ${sidebarOpen ? 'rotate-90' : ''}`} />
              </button>

              <div className="flex mb-6 bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
                <button
                  onClick={() => setActiveTab('uga')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'uga'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Clasificación UGA
                </button>
                <button
                  onClick={() => setActiveTab('descripcion')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'descripcion'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Descripción UGA
                </button>
                <button
                  onClick={() => setActiveTab('politica')}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${
                    activeTab === 'politica'
                      ? 'bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
                  }`}
                >
                  Política Ambiental
                </button>
              </div>

              <AnimatePresence mode="wait">
                <motion.div
                  key={activeTab}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="space-y-6"
                >
                  {activeTab === 'uga' && (
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                        <LayersIcon className="w-5 h-5 text-blue-500 mr-2" />
                        Clasificación de UGAs
                      </h3>
                      <img
                        src="/images/Clave_UGA_Altos_Norte.png"
                        alt="Clasificación de Unidades de Gestión Ambiental"
                        className="w-full h-auto rounded-lg shadow-md mb-4"
                      />
                      <p className="text-sm text-gray-600 dark:text-gray-300">
                        Mapa de clasificación de las Unidades de Gestión Ambiental (UGAs) 
                        de la región Altos Norte.
                      </p>
                    </div>
                  )}

                  {activeTab === 'descripcion' && (
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                        <Info className="w-5 h-5 text-teal-500 mr-2" />
                        Descripción de las UGAs
                      </h3>
                      <p className="text-gray-600 dark:text-gray-300 mb-4">
                        Las <strong>Unidades de Gestión Ambiental (UGAs)</strong> son la unidad mínima 
                        del territorio a la que se asignan determinados lineamientos y estrategias 
                        ecológicas para su manejo específico.
                      </p>
                      <div className="space-y-4">
                        <div className="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 rounded-lg p-4">
                          <h4 className="font-medium text-gray-900 dark:text-white mb-2">Características</h4>
                          <ul className="text-sm text-gray-600 dark:text-gray-300 space-y-1">
                            <li>• Unidad territorial homogénea</li>
                            <li>• Criterios específicos de manejo</li>
                            <li>• Estrategias ecológicas definidas</li>
                            <li>• Monitoreo individualizado</li>
                          </ul>
                        </div>
                        <div className="bg-gradient-to-r from-amber-50 to-orange-50 dark:from-amber-900/20 dark:to-orange-900/20 rounded-lg p-4">
                          <h4 className="font-medium text-gray-900 dark:text-white mb-2">Objetivos</h4>
                          <ul className="text-sm text-gray-600 dark:text-gray-300 space-y-1">
                            <li>• Gestión ambiental específica</li>
                            <li>• Aplicación de lineamientos</li>
                            <li>• Evaluación de resultados</li>
                            <li>• Adaptación de estrategias</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === 'politica' && (
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center">
                        <Target className="w-5 h-5 text-purple-500 mr-2" />
                        Política Ambiental
                      </h3>
                      <p className="text-gray-600 dark:text-gray-300 mb-4">
                        El presente <strong>Modelo de Ordenamiento Ecológico y Territorial Regional</strong> considera una zonificación, integrada por cuatro políticas que buscan definir el estado deseable del territorio mediante lineamientos, estrategias y criterios para conservar y controlar el deterioro del ambiente así como el aprovechamiento sustentable de los recursos naturales.
                      </p>
                    </div>
                  )}
                </motion.div>
              </AnimatePresence>

              <div className="mt-8 pt-6 border-t border-gray-100 dark:border-gray-700">
                <div className="grid grid-cols-2 gap-3">
                  <a
                    href="https://siga.jalisco.gob.mx/ordenamiento/visores/visoraltosnorte/index.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2.5 bg-gradient-to-r from-blue-500 to-teal-500 text-white 
                      rounded-lg text-sm font-medium text-center hover:shadow-lg transition-all"
                  >
                    <ExternalLink className="w-4 h-4 inline mr-1" />
                    Abrir en Nueva Ventana
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          <div className="flex-1">
            <div className="bg-gray-900 rounded-2xl overflow-hidden shadow-2xl">
              <div className="p-4 bg-gradient-to-r from-gray-800 to-gray-900 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-gradient-to-r from-blue-500 to-teal-500 rounded-lg">
                    <GlobeIcon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white">Visor GIS Altos Norte</h3>
                    <p className="text-sm text-gray-400">Sistema interactivo de información geográfica</p>
                  </div>
                </div>
              </div>
              <div className="h-[600px]">
                <iframe
                  src="https://siga.jalisco.gob.mx/ordenamiento/visores/visoraltosnorte/index.html"
                  className="w-full h-full border-0"
                  title="Visor GIS Altos Norte"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const DetailBadge = ({ icon: Icon, label, value }) => (
  <div className="flex items-center p-3 bg-gray-50 dark:bg-gray-700 rounded-xl transition-all hover:bg-teal-100 dark:hover:bg-teal-900/30">
    <Icon className="text-teal-600 dark:text-teal-400 mr-3 flex-shrink-0" size={20} />
    <div className="text-sm">
      <span className="font-semibold text-gray-700 dark:text-gray-300 block leading-tight">{label}:</span>
      <span className="text-gray-900 dark:text-white font-bold">{value}</span>
    </div>
  </div>
);

const Items = [
  {
    title: "Archivos Vectoriales",
    description: "Archivos geoespaciales para la consulta SIG",
    imageUrl: "images/vectoriales.png",
    baseColor: "sky",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/AltosNorte/Descargas/VectorialesAltosNorte.zip",
    target: "_blank",
  },
  {
    title: "Fichas UGAs",
    description: "Informacion detallada de cada Unidad de Gestión Ambiental (UGA).",
    imageUrl: "images/FICHAS_UGA.png",
    baseColor: "green",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/AltosNorte/Descargas/Fichas%20de%20las%20Unidades%20de%20Gesti%C3%B3n%20Ambiental%20Regi%C3%B3n%20Altos%20Norte.pdf",
    target: "_blank",
  },
  {
    title: "Criterios",
    description: "Regulaciones ecológicas para la preservación y restauración del territorio.",
    imageUrl: "images/Criterios.png",
    baseColor: "orange",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/AltosNorte/Descargas/Criterios%20de%20Regulaci%C3%B3n%20Ecol%C3%B3gica%20Regi%C3%B3n%20Altos%20Norte.pdf",
    target: "_blank",
  },
  {
    title: "Estrategías Ecologicas",
    description: "Proyectos de orientación para la protección del entorno natural.",
    imageUrl: "images/Estrategias.png",
    baseColor: "red",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/AltosNorte/Descargas/Lineamientos%20y%20Estrategias%20Ecol%C3%B3gicas%20Regi%C3%B3n%20Altos%20Norte.pdf",
    target: "_blank",
  },
  {
    title: "Lineamientos",
    description: "Conservar, proteger y restaurar los recursos naturales de la región.",
    imageUrl: "images/Lineamientos.png",
    baseColor: "indigo",
    link: "https://siga.jalisco.gob.mx/ordenamiento/archivos/AltosNorte/Descargas/Lineamientos%20y%20Estrategias%20Ecol%C3%B3gicas%20Regi%C3%B3n%20Altos%20Norte.pdf",
    target: "_blank",
  },
];

const StatusBadge = () => {
  return (
    <motion.div 
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-emerald-500/20 to-teal-500/20 
        backdrop-blur-md border border-emerald-500/30"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse mr-2" />
      <span className="text-sm font-medium text-white tracking-wider">FASE </span>
      <div className="ml-2 pl-2 border-l border-white/20">
        <span className="text-xs text-white/70">Vigente</span>
      </div>
    </motion.div>
  );
};

const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    const offset = 80;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

const ModernBanner = ({ onScrollClick }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth) * 100;
      const y = (e.clientY / window.innerHeight) * 100;
      setMousePosition({ x, y });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const stats = [
    { value: '8', label: 'Municipios', icon: MapPin },
    { value: '7,234', label: 'km²', icon: Map },
    { value: '2020', label: 'Publicación', icon: Calendar },
    { value: 'Vigente', label: 'Estado', icon: CheckCircle },
  ];

  return (
    <section className="relative h-screen min-h-[780px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="images/AltosNorte1.jpg"
          alt="Paisaje Altos Norte"
          className="w-full h-full object-cover"
          style={{
            transform: `translate(${mousePosition.x * 0.01}px, ${mousePosition.y * 0.01}px)`,
            transition: 'transform 0.1s ease-out'
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950/80 via-slate-950/60 to-slate-950/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950/20 via-transparent to-slate-950/10" />
      </div>

      <div className="relative z-10 h-full flex items-center px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto w-full">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="mb-6">
                <StatusBadge />
              </div>

              <h1 className="text-5xl md:text-7xl font-black text-white mb-6 leading-tight">
                <span className="bg-gradient-to-r from-cyan-400 to-emerald-400 bg-clip-text text-transparent">
                  Región Altos Norte
                </span>
              </h1>

              <p className="text-xl text-gray-200 mb-8 max-w-xl">
                Estrategia integral para la gestión sustentable del territorio, equilibrando el desarrollo humano con la preservación de los ecosistemas de la región.
              </p>

              <div className="flex flex-wrap gap-4">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  onClick={() => onScrollClick('introduccion')}
                  className="px-8 py-4 bg-gradient-to-r from-cyan-500 to-emerald-500 text-white rounded-xl font-semibold hover:shadow-2xl transition-all"
                >
                  Explorar Región
                </motion.button>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="hidden lg:grid grid-cols-2 gap-4"
            >
              {stats.map((stat, index) => {
                const Icon = stat.icon;
                return (
                  <div key={index} className="text-center">
                    <Icon className="mx-auto mb-2 text-cyan-200" size={24} />
                    <div className="text-2xl font-bold text-white mb-1">{stat.value}</div>
                    <div className="text-xs text-white/70 tracking-wide">{stat.label}</div>
                  </div>
                );
              })}
            </motion.div>
          </div>
        </div>
      </div>

      <motion.div
        animate={{ y: [0, 8, 0] }}
        transition={{ duration: 3, repeat: Infinity }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20"
      >
        <ArrowDown className="text-cyan-400" size={32} />
      </motion.div>
    </section>
  );
};

const imageList = [
  {
    id: '1',
    src: 'images/cabo-corrientes-escudo.png',
    thumbnail: 'images/cabo-corrientes-escudo.png',
    alt: 'Paisaje con montañas',
    caption: 'Cabo Corrientes.'
  },
  {
    id: '2',
    src: 'images/tomatlan-escudo.png',
    thumbnail: 'images/tomatlan-escudo.png',
    alt: 'Ciudad nocturna',
    caption: 'Tomatlán.'
  },
  {
    id: '3',
    src: 'images/la_huerta-escudo.png',
    thumbnail: 'images/la_huerta-escudo.png',
    alt: 'Bosque en otoño',
    caption: 'La Huerta.'
  },
  {
    id: '4',
    src: 'images/cihuatlan-escudo.png',
    thumbnail: 'images/cihuatlan-escudo.png',
    alt: 'Playa tropical',
    caption: 'Cihuatlán.'
  },
];

const municipalities = [
  {
    id: 1,
    name: 'Encarnacion de Diaz',
    shield: 'images/Encarnacion_de_Diaz.png',
    description: 'Con producción agrícola de temporal y ganadería bovina, el municipio se ubica en llanuras semiáridas con suelos fértiles y arroyos estacionales. Su entorno favorece actividades de turismo rural y la aplicación de prácticas de conservación.',
    population: '53,039 habitantes',
    area: '1,253.4 km²',
    foundation: '1917',
    attractions: 'Arroyos temporales, presas rurales y paisajes de matorral y pastizal rodean al municipio, ideales para senderismo y recorridos agroecológicos. Se complementa con visitas a la Parroquia de la Purísima Concepción, la Plaza Principal y antiguas haciendas, además de rutas por zonas agrícolas y ganaderas tradicionales.',
    color: 'from-blue-500 to-teal-600',
    administrativeRegion: 'Altos Norte',
    NumerodeUgas: '15',
    EcologicaZona: ''
  },
  {
    id: 2,
    name: 'Lagos de Moreno',
    shield: 'images/Lagos_de_Moreno.png',
    description: 'Reconocido por la ganadería bovina y la agricultura diversificada, se desarrolla en valles amplios con presencia del río Lagos y áreas de pastizal natural. Estas condiciones permiten el ecoturismo rural y programas de manejo sustentable de cuencas.',
    population: '172,403 habitantes',
    area: '2,514.4 km²',
    foundation: '1879',
    attractions: 'Bordos ganaderos, arroyos estacionales y lomeríos semisecos conforman un entorno ideal para caminatas y observación de aves de pradera. Destacan su Centro Histórico, la Parroquia de la Asunción, el Puente Grande y recorridos por ranchos y zonas de producción lechera y agavera del Altos Norte.',
    color: 'from-green-500 to-emerald-600',
    administrativeRegion: 'Altos Norte',
    NumerodeUgas: '25',
    EcologicaZona: ''
  },
  {
    id: 3,
    name: 'Ojuelos de Jalisco',
    shield: 'images/Ojuelos_de_Jalisco.png',
    description: 'Con agricultura de temporal y ganadería extensiva, el municipio se localiza en zonas semiáridas con matorral, lomeríos y pequeños arroyos intermitentes. Su territorio permite la observación de flora xerófila y la implementación de prácticas de conservación.',
    population: '33,588 habitantes',
    area: '1,156.7 km²',
    foundation: '1874',
    attractions: 'Arroyos intermitentes, bordos y presas pequeñas se integran con un paisaje de matorral y pastizal propio del Altiplano, adecuado para senderismo rural y observación de flora resistente a zonas semiáridas. El municipio cuenta con la Parroquia de San José, la Plaza de Armas, fuertes históricos y rutas por comunidades agrícolas y ganaderas.',
    color: 'from-amber-500 to-orange-600',
    administrativeRegion: 'Altos Norte',
    NumerodeUgas: '13',
    EcologicaZona: ''
  },
  {
    id: 4,
    name: 'San Diego de Alejandría',
    shield: 'images/San_Diego_de_Alejandria.png',
    description: 'Dedicado a la agricultura de temporal y ganadería bovina, el municipio se encuentra en llanuras y lomeríos con suelos fértiles y corrientes de agua estacionales. Su entorno rural facilita el ecoturismo y la ejecución de técnicas de manejo sostenible.',
    population: '7,609 habitantes',
    area: '351.7 km²',
    foundation: '1875',
    attractions: 'Bordos agrícolas, presas y arroyos temporales rodean sus lomeríos semisecos, perfectos para caminatas y rutas rurales. Entre sus atractivos se encuentran la Parroquia de San Diego de Alcalá, la Plaza Principal y recorridos por ranchos y zonas de producción agrícola y agavera tradicional.',
    color: 'from-purple-500 to-indigo-600',
    administrativeRegion: 'Altos Norte',
    NumerodeUgas: '4',
    EcologicaZona: ''
  },
  {
    id: 5,
    name: 'San Juan de los Lagos',
    shield: 'images/San_Juan_de_los_Lagos.png',
    description: 'Con agricultura de temporal y ganadería como actividades principales, se ubica en valles y lomeríos con suelos de buena productividad y arroyos estacionales. Estas características permiten actividades de turismo rural y acciones de conservación de suelos y agua en zonas de cultivo.',
    population: '72,230 habitantes',
    area: '847.7 km²',
    foundation: '1824',
    attractions: 'Arroyos temporales, bordos y presas pequeñas se integran con un paisaje de lomeríos y valles agrícolas, ideales para senderismo rural y observación de aves de pradera. Destacan la Basílica de San Juan de los Lagos, la Plaza Principal, el Templo de la Inmaculada Concepción y rutas por comunidades agrícolas y ganaderas del Altos Norte.',
    color: 'from-purple-500 to-indigo-600',
    administrativeRegion: 'Altos Norte',
    NumerodeUgas: '10',
    EcologicaZona: ''
  },
  {
    id: 6,
    name: 'Teocaltiche',
    shield: 'images/Teocaltiche.png',
    description: 'Sustentado en agricultura de temporal y ganadería extensiva, el municipio se localiza en lomeríos secos y planicies semiáridas con vegetación de matorral. Su entorno favorece la observación de fauna adaptada al clima seco y la implementación de prácticas de conservación.',
    population: '39,839 habitantes',
    area: '933.5 km²',
    foundation: '1861',
    attractions: 'Arroyos estacionales, bordos y pequeñas presas se integran con un paisaje semidesértico ideal para senderismo y observación de flora de los Altos. Destacan la Parroquia de San José, plazas históricas, antiguas haciendas y recorridos rurales vinculados a agricultura, ganadería y rutas por campos de agave.',
    color: 'from-purple-500 to-indigo-600',
    administrativeRegion: 'Altos Norte',
    NumerodeUgas: '14',
    EcologicaZona: 'Área Natural Protegida Zona de Restauración Ecológica Presa el Zapotillo.'
  },
  {
    id: 7,
    name: 'Unión de San Antonio',
    shield: 'images/Union_de_San_Antonio.png',
    description: 'Con actividad agrícola y ganadera, el municipio se encuentra en valles y lomeríos con presencia de arroyos temporales y pastizales naturales. Su territorio permite el turismo rural y la aplicación de estrategias locales de manejo sostenible del suelo.',
    population: '19,069 habitantes',
    area: '728.8 km²',
    foundation: '1835',
    attractions: 'Bordos ganaderos, arroyos temporales y lomeríos de pastizal conforman paisajes propicios para caminatas y rutas rurales. Entre sus atractivos se encuentran la Parroquia de San Antonio, la Plaza Principal, haciendas tradicionales y zonas agrícolas donde se pueden realizar recorridos interpretativos.',
    color: 'from-purple-500 to-indigo-600',
    administrativeRegion: 'Altos Norte',
    NumerodeUgas: '9',
    EcologicaZona: ''
  },
  {
    id: 8,
    name: 'Villa Hidalgo',
    shield: 'images/Villa_Hidalgo.png',
    description: 'Dedicado a la agricultura de temporal y ganadería, se ubica en llanuras semiáridas con suelos de uso agrícola y pequeños cuerpos de agua estacionales. Estas zonas permiten la observación de flora local y la implementación de prácticas de conservación.',
    population: '20,088 habitantes',
    area: '452.9 km²',
    foundation: '1869',
    attractions: 'Arroyos de temporal, bordos agrícolas y extensas llanuras de pastizal caracterizan su entorno natural, ideal para senderismo y observación de paisajes abiertos. El municipio destaca por la Parroquia de San Francisco de Asís, su Plaza Principal, corredores artesanales y visitas a ranchos y zonas de producción agrícola.',
    color: 'from-purple-500 to-indigo-600',
    administrativeRegion: 'Altos Norte',
    NumerodeUgas: '11',
    EcologicaZona: 'Área Natural Protegida Área de Protección de Recursos Naturales CADNR 043 Estado de Nayarit.'
  }
];

const AltosNortePage = () => {
  const [selectedMunicipality, setSelectedMunicipality] = useState(municipalities[0]);
  const aboutContent = `
  <h2 class="text-2xl font-bold mb-4">Ordenamiento Región Altos Norte</h2>

    <p>El Gobierno del Estado de Jalisco impulsa el desarrollo sustentable en la región denominada Altos Norte, integrada por los municipios de Encarnación de Díaz, Lagos de Moreno, Ojuelos de Jalisco, San Diego de Alejandría, San Juan de los Lagos, Teocaltiche, Unión de San Antonio y Villa Hidalgo. Para impulsar dicho desarrollo el Gobierno del Estado de Jalisco y los municipios se coordinarón con el objetivo de realizar los instrumentos necesarios para ordenar el territorio de la región.
Derivado de esto se inició con el proceso de elaboración de los instrumentos, seguido por el proceso de consulta, la cual incluyó amplia participación de los sectores que influyen en el territorio. 

    </p>
    <br>
  `;

  const aboutLinks = [
    { text: 'Programa de Ordenamiento Ecológico y Territorial Regional', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/AltosNorte/Descargas/Programa%20de%20Ordenamiento%20Ecol%C3%B3gico%20Regi%C3%B3n%20Altos%20Norte.pdf' },
    { text: 'Programas Municipales de Desarrollo Urbano (Ver en Inicio)', url: '/descargas/altosnorte' },
  ];

  const aboutDates = [
    { label: 'Fecha Publicación', date: '12/03/2020' },
  ];

  const AltosNorteMain = [
    { id: 0, title: "Publicación en Periódico Oficial", subtitle: "Versión completa", icon: <Book className="w-5 h-5 text-green-400" />,
      url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/AltosNorte/Descargas/Publicacion%20del%20P%C3%A9riodico%20Oficial%20del%20POER%20Region%20Altos%20Norte.pdf"
    },
    { id: 1, title: "POETR Altos Norte", subtitle: "Versión completa", icon: <Map className="w-5 h-5 text-emerald-400" />,
      url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/AltosNorte/Descargas/Programa%20de%20Ordenamiento%20Ecol%C3%B3gico%20Regi%C3%B3n%20Altos%20Norte.pdf"
    },
    { id: '6.1', title: "Proyectos estratégicos", category: "Anexos", url: "https://siga.jalisco.gob.mx/ordenamiento/archivos/AltosNorte/Evaluacion/Informes_de_Evaluacion.zip" },
  ];

  const bitacoraItems = [
    {
      title: 'FASE DE FORMULACIÓN',
      icon: FileSignature,
      color: 'from-blue-500 to-cyan-500',
      content: [
        {
          subtitle: 'Documentos de Gestión',
          items: []
        }
      ]
    },
    {
      title: 'FASE DE EXPEDICIÓN',
      icon: FileSpreadsheet,
      color: 'from-emerald-500 to-green-500',
      content: [
        {
          subtitle: 'Consulta y Participación Ciudadana',
          items: []
        }
      ]
    },
    {
      title: 'FASE DE EJECUCIÓN',
      icon: Zap,
      color: 'from-amber-500 to-orange-500',
      content: [
        {
          subtitle: 'Seguimiento y Monitoreo',
          items: []
        }
      ]
    },
    {
      title: 'FASE DE EVALUACIÓN',
      icon: BarChart3,
      color: 'from-purple-500 to-violet-500',
      content: [
        {
          subtitle: 'Evaluaciones',
          items: [
            { text: 'Informes de Evaluación', url: 'https://siga.jalisco.gob.mx/ordenamiento/archivos/AltosNorte/Evaluacion/Informes_de_Evaluacion.zip' },
          ]
        }
      ]
    }
  ];

  return (
    <div className="environmental-theme fade-in">
      <ModernBanner onScrollClick={scrollToSection} />
 <FullWidthVisorWithSidebar />
      <section id="introduccion" className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-gradient-to-br from-white to-gray-50 dark:from-gray-800 dark:to-gray-900 
              rounded-2xl p-8 shadow-xl border border-gray-100 dark:border-gray-700"
          >
            <div className="flex flex-col lg:flex-row items-start gap-8">
              <div className="lg:w-2/3">
                <div className="flex items-center gap-3 mb-6">
                  <div className="p-2 bg-gradient-to-r from-blue-500 to-teal-500 rounded-lg">
                    <Info className="w-5 h-5 text-white" />
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Ordenamiento Ecológico Regional
                    <span className="block text-lg text-gray-600 dark:text-gray-300 mt-1">
                      Altos Norte
                    </span>
                  </h2>
                </div>
                
                <div className="space-y-4 text-gray-700 dark:text-gray-300">
                  <p>
                    El <strong>Gobierno del Estado de Jalisco</strong> impulsa el desarrollo sustentable 
                    en la región denominada <strong>Altos Norte</strong>, integrada por los municipios de 
                    <strong> Encarnación de Díaz, Lagos de Moreno, Ojuelos de Jalisco, San Diego de Alejandría, San Juan de los Lagos, Teocaltiche, Unión de San Antonio y Villa Hidalgo</strong>.
                  </p>
                  <p>
                    Derivado de esto se inició con el proceso de elaboración de los instrumentos, seguido por el 
                    <strong> proceso de consulta</strong>, la cual incluyó amplia participación de los sectores 
                    que influyen en el territorio.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <section id="DocumentosE" className="py-16 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
        <DocumentRepository2
          items={AltosNorteMain}
          onDownload={(doc) => window.open(doc.url, '_blank')}
          showFooter={false}
        />
      </section>

      <section id="Descargas" className="py-16 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
        <Descargas dataItems={Items} />
      </section>

      <section className="municipalities-section py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-teal-50 to-cyan-100 dark:from-gray-900 dark:to-gray-800 min-h-screen font-sans">
        <div className="container mx-auto max-w-7xl">
          <h2 className="text-4xl md:text-5xl font-extrabold text-teal-800 dark:text-teal-400 text-center mb-16 relative">
            <MapPin className="inline-block mr-3 mb-1 w-10 h-10" />
            Municipios de la Región : Altos Norte
            <p className="text-lg font-normal text-gray-600 dark:text-gray-400 mt-2">
              Conoce los municipios y sus características clave.
            </p>
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {municipalities.map((municipality) => (
              <div 
                key={municipality.id}
                onClick={() => setSelectedMunicipality(municipality)}
                className={`
                  municipality-card rounded-2xl overflow-hidden shadow-xl transition-all duration-500 cursor-pointer 
                  hover:shadow-2xl hover:scale-[1.03] bg-white/90 dark:bg-gray-800/80 backdrop-blur-sm border border-gray-100 dark:border-gray-700
                  ${selectedMunicipality.id === municipality.id 
                    ? 'ring-4 ring-teal-500 scale-[1.03] shadow-teal-300/50 dark:shadow-teal-700/50' 
                    : 'hover:ring-2 hover:ring-teal-300'
                  }
                `}
              >
                <div className={`h-28 ${municipality.color} flex flex-col items-center justify-center p-3 text-white font-bold`}>
                  <img 
                    src={municipality.shield} 
                    alt={`Escudo de ${municipality.name}`} 
                    className="h-14 w-14 object-contain mb-1 drop-shadow-md"
                    onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/64x64/000000/ffffff?text=E"; }}
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-xl font-extrabold text-center text-gray-900 dark:text-white">{municipality.name}</h3>
                  <p className="text-xs text-center text-teal-600 dark:text-teal-400 mt-1 flex items-center justify-center">
                    Ver Detalles <ChevronRight className='w-3 h-3 ml-1'/>
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div 
            key={selectedMunicipality.id}
            className="municipality-details bg-white dark:bg-gray-800 rounded-3xl shadow-2xl p-8 md:p-12 max-w-6xl mx-auto border border-teal-200 dark:border-teal-900 animate-fade-in-up"
            style={{ '--delay': '200ms' }}
          >
            <div className="flex flex-col md:flex-row items-start gap-10">
              <div className="w-full md:w-1/3 flex flex-col items-center justify-center p-4 bg-gray-50 dark:bg-gray-700 rounded-xl">
                <img 
                  src={selectedMunicipality.shield} 
                  alt={`Escudo de ${selectedMunicipality.name}`} 
                  className="h-48 w-48 object-contain shadow-lg rounded-full p-2 bg-white dark:bg-gray-900 mb-6 border-4 border-teal-300 dark:border-teal-500"
                  onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/192x192/000000/ffffff?text=E"; }}
                />
                <h3 className="text-3xl font-bold mb-2 text-gray-900 dark:text-white text-center">{selectedMunicipality.name}</h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm text-center italic mt-2">{selectedMunicipality.description}</p>
              </div>
              
              <div className="w-full md:w-2/3">
                <h4 className="text-2xl font-bold text-teal-700 dark:text-teal-400 mb-6 border-b border-gray-200 dark:border-gray-700 pb-2 flex items-center">
                  <Info className='w-5 h-5 mr-2'/> Datos Clave
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <DetailBadge icon={Users} label="Población" value={selectedMunicipality.population} />
                  <DetailBadge icon={Map} label="Superficie" value={selectedMunicipality.area} />
                  <DetailBadge icon={Calendar} label="Municipalización" value={selectedMunicipality.foundation} />
                  <DetailBadge icon={Landmark} label="Región Administrativa" value={selectedMunicipality.administrativeRegion} />
                  <DetailBadge icon={MapPin} label="Número de UGAs" value={selectedMunicipality.NumerodeUgas} />
                  <DetailBadge icon={MountainSnow} label="Zonas de Importancia Ecológica" value={selectedMunicipality.EcologicaZona} />
                </div>
                
                <div className="mt-8 pt-4 border-t border-gray-200 dark:border-gray-700">
                  <h4 className="text-xl font-bold text-gray-900 dark:text-white mb-3 flex items-center">
                    <Waves className='text-blue-500 mr-2 w-5 h-5'/> Principales Atracciones
                  </h4>
                  <p className="text-gray-700 dark:text-gray-300 leading-relaxed bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-100 dark:border-blue-800">
                    {selectedMunicipality.attractions}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     

      <ModernBitacoraSection items={bitacoraItems} />

      <FasesSection 
        imageUrl="images/FasesOrdenamiento.png"
        altText="Fases del Ordenamiento Altos Norte"
      />
    </div>
  );
};

export default AltosNortePage;
